import React from 'react';

const Recordings = () => {
  return (
    <section
      id="recordings"
      className="pt-16 pb-16 px-8 lg:px-32 text-white"
      style={{ backgroundColor: '#1a1a1a' }}
    >
      <div className="container mx-auto">
        {/* Title */}
        <h2 className="text-3xl font-medium text-center mb-8" style={{ fontFamily: "'EB Garamond', serif" }}>
          RECORDINGS
        </h2>

        {/* Recordings Grid */}
        <div className="flex flex-wrap justify-center gap-6 mb-8">
          {/* Recording 1 */}
          <div className="bg-black aspect-square w-48 sm:w-64 flex flex-col items-center justify-center text-white pt-4 pb-4 rounded-lg overflow-hidden shadow-lg">
            <iframe
              src="https://fast.wistia.net/embed/iframe/h6sc6wju0k"
              allow="autoplay; fullscreen; picture-in-picture"
              className="w-full h-full"
              title="Sally Heath Recording 1"
              aria-label="Audio recording by Sally Heath"
            ></iframe>
          </div>

          {/* Recording 2 */}
          <div className="bg-black aspect-square w-48 sm:w-64 flex flex-col items-center justify-center text-white pt-4 pb-4 rounded-lg overflow-hidden shadow-lg">
            <iframe
              src="https://fast.wistia.net/embed/iframe/a1twtwm88l"
              allow="autoplay; fullscreen; picture-in-picture"
              className="w-full h-full"
              title="Sally Heath Recording 2"
              aria-label="Audio recording by Sally Heath"
            ></iframe>
          </div>

          {/* Recording 3 */}
          <div className="bg-black aspect-square w-48 sm:w-64 flex flex-col items-center justify-center text-white pt-4 pb-4 rounded-lg overflow-hidden shadow-lg">
            <iframe
              src="https://fast.wistia.net/embed/iframe/3puo8ovvbf"
              allow="autoplay; fullscreen; picture-in-picture"
              className="w-full h-full"
              title="Sally Heath Recording 3"
              aria-label="Audio recording by Sally Heath"
            ></iframe>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Recordings;
